import { useState, useEffect } from 'react'

export function useLineClamp(ref: React.RefObject<null>, lineHeight = 18) {
  const [clamp, setClamp] = useState<number | null>(null)

  useEffect(() => {
    if (!ref.current) return

    const observer = new ResizeObserver(([entry]) => {
      const lines = Math.floor(entry.contentRect.height / lineHeight)
      setClamp(lines > 0 ? lines : 1)
    })

    observer.observe(ref.current)
    return () => observer.disconnect()
  }, [lineHeight, ref])

  return clamp
}
